import * as Config from '@/Config'

export default class Util {
  /**
   * クイズイメージ取得
   * @param qmId
   * @returns {string}
   */
  static getQuestionImage (qmId) {
    return `${window.vars.api_base_url}/image.php?type=${window.vars.question_type}&id=${qmId}`
  }

  /**
   * 回答イメージ取得
   * @param qmId
   * @returns {string}
   */
  static getAnswerImage (qmId) {
    return `${window.vars.api_base_url}/image.php?type=${window.vars.answer_type}&id=${qmId}`
  }

  static getDateTime (timestamp) {
    const dateTime = new Date(timestamp * 1000)
    const y = dateTime.getFullYear()
    const m = dateTime.getMonth() + 1
    const d = dateTime.getDate()
    return `${y}/${m}/${d}`
  }

  /**
   * ページ番号に応じたqmListを絞って返す
   * @param pageNumber
   * @param qmList
   */
  static limitedQmList (pageNumber, qmList) {
    const list = {}
    const keys = Object.keys(qmList)
    const len = keys.length
    const start = (pageNumber - 1) * Config.VIEW_MAX_LIST_NUMBER
    const end = start + Config.VIEW_MAX_LIST_NUMBER
    for (let i = 0; i < len; i++) {
      if (start <= i && i < end) {
        const key = keys[i]
        list[key] = qmList[key]
      }
    }
    return list
  }
}
